import { useState, type FormEvent } from "react";
import { Rocket } from "lucide-react";

interface LoginProps {
  onLogin: (code: string) => void;
  /** Por qué se volvió al login, si no fue por cerrar sesión. */
  aviso?: string | null;
}

export function Login({ onLogin, aviso = null }: LoginProps) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(false);
    setLoading(true);

    try {
      const res = await fetch("/api/stats", {
        headers: { Authorization: `Bearer ${code}` },
      });
      if (res.ok) {
        onLogin(code);
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0D1117] flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-[#161B22] border border-[#30363D] rounded-xl p-8 space-y-6"
      >
        <div className="text-center space-y-2">
          <Rocket className="w-10 h-10 text-cyan-400 mx-auto" />
          <h1 className="text-xl font-semibold text-gray-100">
            SORV Mission Control
          </h1>
          <p className="text-sm text-gray-500">Ingresa el codigo de acceso</p>
        </div>

        {aviso && (
          <p role="status" className="text-amber-400 text-sm text-center">
            {aviso}
          </p>
        )}

        <div>
          <input
            type="password"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError(false);
            }}
            placeholder="Codigo de acceso"
            autoFocus
            className="w-full px-4 py-3 bg-[#0D1117] border border-[#30363D] rounded-lg text-gray-100 placeholder-gray-600 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 text-center tracking-widest"
          />
          {error && (
            <p className="text-red-400 text-sm text-center mt-2">
              Codigo incorrecto
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading || !code}
          className="w-full py-3 bg-cyan-600 hover:bg-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors"
        >
          {loading ? "Verificando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
